
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.694.21l-3.537 3.361L10.621.21 9.534 1.245l4.623 4.403 4.623-4.403L17.694.21z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M10.62 0l3.537 3.361L17.694 0 19 1.244l-4.843 4.613-4.843-4.613L10.621 0zm0 .419l-.866.825 4.403 4.194 4.403-4.194-.866-.825-3.537 3.361L10.621.419zM0 11.562V9.386h18.78v2.176H0zm0 3.263V17h18.78v-2.175H0z"}})])
          )
        }
      }
    